

module.exports = __webpack_require__.stylable.create(
    "EmptyState4038795744",
    {"classes":{"root":"EmptyState4038795744__root","title":"EmptyState4038795744__title","text":"EmptyState4038795744__text"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "EmptyState4038795744",
    null
);
